import { ImportProvider } from './ImportProvider';
import { ImportPreview } from './ImportPreview/ImportPreview';
import { ImportProgress } from './ImportProgress/ImportProgress';
import { ImportUploadZone } from './ImportUploadZone/ImportUploadZone';
import { ImportFileDescription } from './ImportFileDescription';
import { ImportDownloadTemplateButton } from './ImportDownloadTemplateButton';
import { ImportDownloadErrorsButton } from './ImportDownloadErrorsButton';
import { ImportSubmitButton } from './ImportSubmitButton';
import { ImportCompletedMessage } from './ImportCompletedMessage';
import { ImportTemplate } from './ImportTemplate/ImportTemplate';
export { useImportContext } from './ImportProvider';

export const Import = {
    Provider: ImportProvider,
    Preview: ImportPreview,
    Progress: ImportProgress,
    UploadZone: ImportUploadZone,
    ImportTemplate: ImportTemplate,
    FileDescription: ImportFileDescription,
    DownloadTemplateButton: ImportDownloadTemplateButton,
    DownloadErrorsButton: ImportDownloadErrorsButton,
    SubmitButton: ImportSubmitButton,
    CompletedMessage: ImportCompletedMessage,
};
